import { makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';

class IconeJulgar extends ReactComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="26"
                height="24"
            >
                <defs>
                    <path
                        id="a"
                        d="M0 0h24v24H0V0z"
                    />
                </defs>
                <clipPath id="b">
                    <use
                        xlinkHref="#a"
                        overflow="visible"
                    />
                </clipPath>
                <path
                    d="M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"
                    clipPath="url(#b)"
                    transform="matrix(.70247 0 0 .70247 -.619 -.58)"
                    fill={this.observableProps.cor ?? 'black'}
                />
                <text
                    style={{ lineHeight: 1.25 }}
                    x="14.659"
                    y="23.626"
                    fontWeight="400"
                    fontSize="12.535"
                    letterSpacing="0"
                    wordSpacing="0"
                    fontFamily="sans-serif"
                    strokeWidth="1.567"
                >
                    <tspan
                        x="14.659"
                        y="23.626"
                        // @ts-ignore
                        style={{ InkscapeFontSpecification: 'FreeSans Semi-Bold' }}
                        fontWeight="600"
                        fontSize="14.624"
                        fontFamily="FreeSans"
                        fill={this.observableProps.cor ?? 'black'}
                    >
                        {this.observableProps.letra ?? 'J'}
                    </tspan>
                </text>
            </svg>
        );
    }
}

export default inject('stores')(observer(IconeJulgar));
